<template>
  <v-dialog :value="value" max-width="520" @input="updateDialog">
    <v-card>
      <v-toolbar dark color="error" class="elevation-2">
        <v-toolbar-title class="font-weight-bold">
          {{ title }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="onCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="py-6">
        <slot />
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-4">
        <v-btn text @click="onCancel">
          {{ $t('miscellaneous.cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn color="error" :loading="loading" @click="$emit('confirm')">
          {{ $t('miscellaneous.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ArenaProductDeleteDialog',
  props: {
    value: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  methods: {
    updateDialog(val) {
      this.$emit('input', val)
    },
    onCancel() {
      this.updateDialog(false)
      this.$emit('cancel')
    },
  },
}
</script>
